import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    ref: "observerRef",
    class: "progress-bar-wrapper"
};
const _hoisted_2 = { colspan: "9" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_ReportRow = _resolveComponent("ReportRow");
    const _component_v_progress_circular = _resolveComponent("v-progress-circular");
    const _component_ReportTotalRow = _resolveComponent("ReportTotalRow");
    const _component_v_data_table = _resolveComponent("v-data-table");
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(`content-wrapper ${_ctx.wrapperClass}`)
    }, [
        _createVNode(_component_v_data_table, {
            hover: "",
            class: "report-table brg-table",
            "fixed-header": "",
            "fixed-footer": "",
            "must-sort": "",
            density: "compact",
            "no-data-text": _ctx.noDataText,
            items: _ctx.visibleItems,
            "items-per-page": -1,
            options: _ctx.tableOption,
            headers: _ctx.tableHeader,
            style: _normalizeStyle(_ctx.cssVars)
        }, {
            [`item`]: _withCtx(({ item }) => [
                _createVNode(_component_ReportRow, {
                    item: item,
                    headers: _ctx.tableHeader
                }, null, 8 /* PROPS */, ["item", "headers"])
            ]),
            [`body.append`]: _withCtx(() => [
                _withDirectives(_createElementVNode("tr", _hoisted_1, [
                    _createElementVNode("td", _hoisted_2, [
                        _createVNode(_component_v_progress_circular, {
                            indeterminate: "",
                            color: "blue",
                            size: "24"
                        })
                    ])
                ], 512 /* NEED_PATCH */), [
                    [_vShow, _ctx.isSpinnerExist]
                ])
            ]),
            tfoot: _withCtx(() => [
                _createVNode(_component_ReportTotalRow, {
                    headers: _ctx.tableHeader,
                    report: _ctx.report
                }, null, 8 /* PROPS */, ["headers", "report"])
            ]),
            bottom: _withCtx(() => _cache[0] || (_cache[0] = [])),
            _: 2 /* DYNAMIC */
        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["no-data-text", "items", "options", "headers", "style"])
    ], 2 /* CLASS */));
}
